<app-website-header></app-website-header>

<!-- Page Banner -->
<section class="page-banner">
    <div class="banner-content">
        <h1>Get in <span class="highlight">Touch</span></h1>
        <p>We'd love to hear from you. Reach out for inquiries, quotes, or service support.</p>
    </div>
</section>

<!-- Contact Section -->
<section class="contact-section">
    <div class="section-container">
        <div class="contact-grid">
            <!-- Contact Info Cards -->
            <div class="contact-info">
                <div class="info-card">
                    <div class="info-icon"><i class="fas fa-map-marker-alt"></i></div>
                    <div class="info-details">
                        <h4>Chennai Office</h4>
                        <p>Plot No. 8, Dharmalingam Nagar<br>Opp. A.R. Weigh Bridge<br>Thiruneermalai Road<br>Chennai –
                            600 169, Tamil Nadu</p>
                    </div>
                </div>

                <div class="info-card">
                    <div class="info-icon"><i class="fas fa-map-marker-alt"></i></div>
                    <div class="info-details">
                        <h4>Hosur Office</h4>
                        <p>No. 5/10, Plot No. 11<br>Bedarapallai Road<br>Santhapuram Agraharam<br>Hosur – 635 136, Tamil
                            Nadu</p>
                    </div>
                </div>

                <div class="info-card">
                    <div class="info-icon"><i class="fas fa-phone-alt"></i></div>
                    <div class="info-details">
                        <h4>Call Us</h4>
                        <p>
                            <a href="tel:+919036022687">+91 90360 22687</a> (MD)<br>
                            <a href="tel:+919513266444">+91 95132 66444</a> (Office)
                        </p>
                    </div>
                </div>

                <div class="info-card">
                    <div class="info-icon"><i class="fas fa-envelope"></i></div>
                    <div class="info-details">
                        <h4>Email Us</h4>
                        <p>
                            <a
                                href="mailto:manikandan@aathreyamachinetools.com">manikandan&#64;aathreyamachinetools.com</a><br>
                            <a href="mailto:aathreyamachinetools@gmail.com">aathreyamachinetools&#64;gmail.com</a>
                        </p>
                    </div>
                </div>

                <div class="info-card">
                    <div class="info-icon"><i class="fas fa-clock"></i></div>
                    <div class="info-details">
                        <h4>Business Hours</h4>
                        <p>Mon – Sat: 9:00 AM – 6:00 PM<br>Sunday: Closed</p>
                    </div>
                </div>
            </div>

            <!-- Contact Form -->
            <div class="contact-form-wrapper">
                <h3>Send Us a Message</h3>
                <p class="form-desc">Fill in the form below and we'll get back to you as soon as possible.</p>
                <form (ngSubmit)="onSubmit()" class="contact-form">
                    <div class="form-row">
                        <div class="form-group">
                            <label>Your Name *</label>
                            <input type="text" [(ngModel)]="formData.name" name="name" placeholder="Enter your name"
                                required>
                        </div>
                        <div class="form-group">
                            <label>Email Address *</label>
                            <input type="email" [(ngModel)]="formData.email" name="email" placeholder="Enter your email"
                                required>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group">
                            <label>Phone Number</label>
                            <input type="tel" [(ngModel)]="formData.phone" name="phone"
                                placeholder="Enter your phone number">
                        </div>
                        <div class="form-group">
                            <label>Subject *</label>
                            <input type="text" [(ngModel)]="formData.subject" name="subject"
                                placeholder="What is this about?" required>
                        </div>
                    </div>
                    <div class="form-group full-width">
                        <label>Message *</label>
                        <textarea [(ngModel)]="formData.message" name="message" rows="5"
                            placeholder="Type your message here..." required></textarea>
                    </div>
                    <button type="submit" class="btn-submit">
                        <i class="fas fa-paper-plane"></i> Send Message
                    </button>
                </form>
            </div>
        </div>
    </div>
</section>

<app-website-footer></app-website-footer>